import React, { useEffect, useState } from "react"
import { graphql } from "gatsby"
import CareerPage from "../components/career/CareerPage"
import "../styles/careerPage.scss"
import axios from 'axios'

const Career = ({ data }) => {
  const [career, setCareerData] = useState([])

  useEffect(() => {
    axios.get('https://staging.visiomate.com/jobpositions').then((res) => {
      setCareerData([...JSON.parse(res.data.result).data]);
    })
  }, []);

  return (
    <CareerPage
      heroDeskPhoto={data.heroDeskPhoto?.childImageSharp?.gatsbyImageData}
      heroPhoto={data.heroPhoto?.childImageSharp?.gatsbyImageData}
      careerData={[...career]}
    />
  )
}

export default Career
export const query = graphql`
  query CareerImages {
    heroDeskPhoto: file(relativePath: { eq: "lifeatvisiomate/good_environement1.webp" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 900, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    heroPhoto: file(relativePath: { eq: "lifeatvisiomate/visiomate_branding.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 700, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
  }
`
